import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchWasteOverview() {
    const endpoint = '/api/multiutility/waste-overview';

    const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

    return response.data;
}